$nav = jQuery("#headerMenu");
window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());

jQuery(document).ready(function () {
 
    jQuery(".menu-item-has-children").prepend("<i class='menu-icon fas fa-chevron-down'></i>");
 
    if (window.isMobile) {


        jQuery(".menu-item-has-children").click(function (e) {
            if (jQuery(this).hasClass("is_open")) {

                jQuery(this).children(".sub-menu").slideUp("fast", function () {
                    console.log("Sub Closed");

                    jQuery(".is_open").removeClass("is_open");
                    jQuery(this).parent().find('[data-fa-i2svg]')
                        .toggleClass('fa-chevron-down')
                        .toggleClass('fa-times');

                });


            } else {
                e.preventDefault();
                jQuery(".is_open").children(".sub-menu").slideUp("fast", function () {
                    // console.log("Sub Closed");

                    jQuery(this).parent(".is_open").removeClass("is_open");
                    jQuery(this).parent().find('[data-fa-i2svg]')
                        .toggleClass('fa-chevron-down')
                        .toggleClass('fa-times');
                });

                jQuery(this).children(".sub-menu").slideToggle("fast", function () {
                    // console.log("Sub Open");
                    jQuery(this).parent().addClass("is_open");
                    jQuery(this).parent().find('[data-fa-i2svg]')
                        .toggleClass('fa-chevron-down')
                        .toggleClass('fa-times');
                });

            }
        });


        //Menu Toggle

        $toggle = jQuery("#menuToggle");
        $menu = jQuery("#headerMenu");
        $toggle.click(function () {
            $menu.slideToggle();
            $toggle.toggleClass("is_open");
            jQuery(this).parent().children('svg')
                .toggleClass('fa-bars')
                .toggleClass('fa-times');


        });


    }



    // Search Open & Close

    var search = jQuery("#header__search");
    var search_button = search.find("#searchsubmit");

    search_button.click(function(e){

        if(search.hasClass('is_open')){


        } else {
            e.preventDefault();
            search.addClass("is_open");

        }
    })


}); 